import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import router from './router'
import App from './App.vue'
import './styles/main.scss'
import { initMicroApps } from './micro-apps'

// 创建Vue应用实例
const app = createApp(App)

// 配置Pinia状态管理
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)

// 配置Element Plus
app.use(ElementPlus, {
  locale: zhCn
})

// 配置路由
app.use(router)

// 挂载应用
app.mount('#app')

// 初始化微前端应用
initMicroApps() 